import React from "react";
import { BlocksComponent } from "../../Components/Blocks";
import Wrapper from "../../Components/Wrapper/wrapper";

export const Blocks = () => {
  return (
    <Wrapper header={"Block"}>
      <BlocksComponent />
    </Wrapper>
  );
};
